import { render, staticRenderFns } from "./DeleteTabModal.vue?vue&type=template&id=04d03409&scoped=true"
import script from "./DeleteTabModal.vue?vue&type=script&lang=js"
export * from "./DeleteTabModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteTabModal.vue?vue&type=style&index=0&id=04d03409&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d03409",
  null
  
)

export default component.exports